/* klar-use-cases.js */
(function () {
  document.querySelectorAll(".klar-uc__slider").forEach(function (slider) {
    var track = slider.querySelector(".klar-uc__track");
    var dots = slider.querySelectorAll(".klar-uc__dot");
    var cards = slider.querySelectorAll(".klar-uc__card");

    if (!track || !dots.length || !cards.length) return;

    // Click dot → scroll to card
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        cards[i].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      });
    });

    // Update active dot based on which card is most visible
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.prototype.indexOf.call(cards, entry.target);
            dots.forEach(function (d) {
              d.classList.remove("is-active");
            });
            if (dots[idx]) dots[idx].classList.add("is-active");
          }
        });
      },
      { root: track, threshold: 0.5 },
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  });
})();
